/**
 * Builds the `notifications_dropdown_opened` event fired when the header
 * bell icon opens its menu. The bell sits behind the menu's own backdrop
 * once open, so every click that reaches the icon's `onClick` is a genuine
 * open — see Header.jsx.
 */

import { getSessionId } from "./session";
import type { NotificationsDropdownOpenedEvent } from "./types";

export const buildNotificationsDropdownOpenedEvent = (
  unreadCount: number,
): NotificationsDropdownOpenedEvent => ({
  name: "notifications_dropdown_opened",
  occurred_at: new Date().toISOString(),
  session_id: getSessionId(),
  hub_id: null,
  project_id: null,
  properties: { unread_count: unreadCount },
});
